import { t } from '../../../strings/i18n';
import { required } from '../../../xform';
export const FIRST_NAME_INPUT_NAME = 'firstName';
const firstNameConfig = () => [
    FIRST_NAME_INPUT_NAME,
    undefined,
    'ENABLED',
    [required(t('errors.firstNameRequired'))]
];
export default firstNameConfig;
